import { Button, Input, message } from 'antd';
import { FetchResult } from 'apollo-link';
import gql from 'graphql-tag';
import React, { useEffect, useRef } from 'react';
import { useApolloClient, useMutation } from 'react-apollo-hooks';

import { WrapPasswordPage } from './index.styled';

const Login = (props) => {
  const getInputFieldCollection = () => {
    const inputElements: HTMLCollectionOf<Element> =
      document.getElementsByClassName("inputField");

    const inputFields = inputElements as HTMLCollectionOf<HTMLInputElement>;
    return inputFields;
  };

  const findNextInput = () => {
    const inputFields = getInputFieldCollection();
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < inputFields.length; i++) {
      if (inputFields[i].value === "") {
        inputFields[i].focus();
        break;
      }
    }
  };

  const combinePassword = () => {
    let ret = "";
    const inputFields = getInputFieldCollection();

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < inputFields.length; i++) {
      if (inputFields[i].value !== "") {
        ret += String(inputFields[i].value);
      }
    }

    return ret;
  };

  const PASSWORD_CHECK = gql`
    mutation PasswordCheck($password: String!, $ordno: String!) {
      passwordCheck(password: $password, ordno: $ordno) {
        success
        message
      }
    }
  `;

  useEffect(() => {
    const firstInput = firstFieldRef.current! as HTMLInputElement;
    firstInput.focus();
  }, []);

  const { ordno } = props;

  const [passwordChkMutation] = useMutation(PASSWORD_CHECK);
  const client = useApolloClient();

  const firstFieldRef = useRef();

  return (
    <WrapPasswordPage>
      <div className="centerDiv">
        <div className="logoSection">
          <img src="images/common/logo_white.png" />
        </div>
        <div className="titleSection">
          Cakefactory
          <br />
          SweetBlossom
        </div>
        <div className="descriptionSection">
          주문하신 케익의 디자인을 직접 편집하실수 있어요 :)
          <br />
          메시지로 받으신 개인 비밀번호를 입력해주세요.
        </div>
        <div className="passwordSection">
          <Input
            size="large"
            className="inputField"
            maxLength={1}
            onChange={findNextInput}
            id="pw1"
            ref={firstFieldRef as any}
          />
          <Input
            size="large"
            className="inputField"
            maxLength={1}
            id="pw2"
            onChange={findNextInput}
          />
          <Input
            size="large"
            className="inputField"
            maxLength={1}
            id="pw3"
            onChange={findNextInput}
          />
          <Input
            size="large"
            className="inputField"
            maxLength={1}
            id="pw4"
            onChange={findNextInput}
          />
        </div>
        <div className="buttonSection">
          <Button
            ghost={true}
            onClick={async () => {
              let status = false;
              await passwordChkMutation({
                variables: {
                  password: combinePassword(),
                  ordno,
                },
                update: (cache, response: FetchResult<any>) => {
                  if (!response.data.passwordCheck.success) {
                    message.error(response.data.passwordCheck.message);
                  } else {
                    status = true;
                  }
                },
              });

              client.writeData({
                data: {
                  app: {
                    __typename: "AppSetting",
                    passwordCheck: status,
                  },
                },
              });
            }}
          >
            스케치시작하기!
          </Button>
        </div>
        <div className="failSection">
          <div className="title">비밀번호가 맞지 않으세요?</div>
          <Button
            type={"dashed"}
            ghost={true}
            onClick={() => {
              location.href = "http://pf.kakao.com/_APgfxd/chat";
            }}
          >
            카톡으로문의하기
          </Button>
          <Button
            type={"dashed"}
            ghost={true}
            onClick={() => {
              location.href = "tel:15449560";
            }}
          >
            고객센터로전화하기
          </Button>
        </div>
      </div>
    </WrapPasswordPage>
  );
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/index.tsx